import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { useQuery } from '@tanstack/react-query';
import { Space, Radio, Select, Typography } from 'antd';
import uniqBy from 'lodash/uniqBy';
import { getTranslatedString } from 'helpers/i18n';
import { apiGet } from 'helpers/ApiHelper';

const { Text } = Typography;

const fetchAgentProperties = async (userId) => {
  const response = await apiGet(`/landlords/user`, { user_type: 'Agent', user_id: userId });

  return response?.user?.properties || [];
};

const ApplicationReviewNotificationsSettings = ({ userId }) => {
  const { data: properties } = useQuery({
    queryKey: ['agentProperties', userId],
    queryFn: () => fetchAgentProperties(userId),
  });

  const allPropertiesOptions = uniqBy(properties || [], (property) => property.value).map(
    ({ value, label }) => ({ value, label })
  );

  return (
    <Space direction="vertical" style={{ width: '100%', marginTop: 8 }}>
      <Field
        name="application_review_notifications_settings.send_notifications_for"
        component={(field) => (
          <Space direction="vertical">
            <Text>
              {getTranslatedString(
                'landlordPortal.userPreferencesForm.label.applicationReviewNotifications.sendNotificationsFor'
              )}
            </Text>
            <Radio.Group
              value={field.input.value}
              onChange={({ target: { value } }) => field.input.onChange(value)}
              options={[
                {
                  label: getTranslatedString(
                    'landlordPortal.userPreferencesForm.label.applicationReviewNotifications.sendNotificationsFor.allApplications'
                  ),
                  value: 'all_applications',
                },
                {
                  label: getTranslatedString(
                    'landlordPortal.userPreferencesForm.label.applicationReviewNotifications.sendNotificationsFor.applicationsAssignedToMeOnly'
                  ),
                  value: 'applications_assigned_to_me',
                },
              ]}
            />
          </Space>
        )}
      />
      <Field
        name="application_review_notifications_settings.properties"
        component={(field) => {
          const value =
            typeof field.input.value == 'string' ? [field.input.value] : field.input.value;

          const allAssignedProperties = {
            label: getTranslatedString(
              'landlordPortal.userPreferencesForm.label.applicationReviewNotifications.properties.allAssignedProperties'
            ),
            value: 'all_assigned_properties',
          };

          const showAllAssignedPropertiesOption = !allPropertiesOptions.some((property) =>
            value.includes(property.value)
          );
          const showPropertiesOptions = !value.includes('all_assigned_properties');

          const options = [
            ...(showAllAssignedPropertiesOption ? [allAssignedProperties] : []),
            ...(showPropertiesOptions ? allPropertiesOptions : []),
          ];

          const onChange = (value) => {
            if (value[0] === 'all_assigned_properties') {
              return field.input.onChange(value[0]);
            }

            return field.input.onChange(value);
          };

          return (
            <Space direction="vertical" style={{ width: '100%' }}>
              <Text>
                {getTranslatedString(
                  'landlordPortal.userPreferencesForm.label.applicationReviewNotifications.properties'
                )}
              </Text>
              <Select
                mode="multiple"
                options={options}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                value={value}
                style={{ width: '100%' }}
                onChange={onChange}
              />
            </Space>
          );
        }}
      />
    </Space>
  );
};

export default connect((state) => ({
  userId: state.userTypes.userId,
}))(ApplicationReviewNotificationsSettings);
